import { render, staticRenderFns } from "./StrokeFullSideIcon.vue?vue&type=template&id=27972394&"
import script from "./StrokeFullSideIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeFullSideIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports